module.exports = __webpack_public_path__ + "static/media/b74b6417-787c-4745-b2f9-d29cace95a3e.95848941.JPG";